module.exports = __webpack_public_path__ + "img/google.95c49c82.svg";